import script from "./TraitShopCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitShopCategories.vue?vue&type=script&setup=true&lang=js"

import "./TraitShopCategories.vue?vue&type=style&index=0&id=e3b57bfc&lang=scss"

const __exports__ = script;

export default __exports__